import { module } from 'stereomodularjs';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        this.buttons = this.el.querySelectorAll('.js-collection-filter');
        this.items = this.el.querySelectorAll('.js-collection-item');

        // When a filter button is clicked
        this.buttons.forEach(button => {
            button.addEventListener('click', () => {
                this.filter(button);
                this.setActiveButton(button);
            });
        });
    }

    // Filter the collection
    filter(button) {
        const filter = button.getAttribute('data-filter');

        // Show all items
        if (filter === 'all') {
            this.items.forEach(item => {
                item.classList.remove('hidden');
            });
        } else {
            // Hide all items
            this.items.forEach(item => {
                item.classList.add('hidden');
            });

            // Show items that match the filter
            this.items.forEach(item => {
                const itemFilters = item.getAttribute('data-filter').split(' ');
                if (itemFilters.includes(filter)) {
                    item.classList.remove('hidden');
                }
            });
        }
    }

    // Set active button
    setActiveButton(button) {
        this.buttons.forEach(btn => {
            btn.classList.remove('is-active');
        });
        button.classList.add('is-active');
    }

    destroy() {
        this.buttons.forEach(button => {
            button.removeEventListener('click', this.filter);
        });
    }
}